export default __webpack_public_path__ + "static/media/3.0977c4ba.jpg";